const passkey_sign_in = {
    setup_page: {
        title: 'Uprość logowanie',
        subtitle: 'Utwórz klucz dostępu',
        description: 'Zarejestruj klucz dostępu za pomocą biometrii urządzenia, kluczy zabezpieczających, takich jak YubiKey, lub innych dostępnych metod.',
    },
    trigger_conditional_ui_failed: 'Nie udało się uruchomić autouzupełniania passkey.',
};
export default Object.freeze(passkey_sign_in);
